export const environment = {
  production: true,
  endpoint: 'https://core-neighbors-qr.vercel.app/api',
  secure: 'awmxGyRg7KEGViAjXm3JBC9po49lc0r3452',
  firebaseConfig: {
    apiKey: "AIzaSyCCvcbxPE6aCHJl1dIy3Yp9Kju4qdRu4mw",
    authDomain: "neighbors-qr.firebaseapp.com",
    projectId: "neighbors-qr",
    storageBucket: "neighbors-qr.appspot.com",
    messagingSenderId: "737364946867",
    appId: "1:737364946867:web:f476cb1ab79860573a25c6",
    measurementId: "G-BTH9TX33MM"
  }
};
